export default "__VITE_ASSET__ac1313c7__"